export default __webpack_public_path__ + "static/media/facebook.bfec55b8.png";